export default {
  data: {
    name: 'Nome',
    phone: 'Telefone',
    fax: 'Fax',
    email: 'Email',
    department: 'Departamento',
    departmentCode: 'Código do departamento',
    assignedAccountId: 'Código Conta Contábil',
    assignedAccountIdTooltip: 'Digite aqui o código associado ao seu software de contabilidade'
  },
  options: {
    faceB2b: 'DIRe (FACeB2B)',
    faceDir3: 'DIR3 (FACe)',
    noFace: 'Nenhum'
  },
  mandatory: {
    email: 'Se o receptor não pertence à plataforma, ele será avisado por email'
  },
  additionalInfo: {
    code: 'Código',
    description: 'Descrição',
    postalCode: 'Código Postal',
    address: 'Endereço',
    street: 'Endereço',
    town: 'Cidade',
    city: 'Estado',
    country: 'País',
    name: 'Nome',
    firstname: 'Primeiro Sobrenome',
    lastname: 'Segundo Sobrenome'
  }
}